import _debounce from "lodash.debounce/index";


const readyStates = {
    loading: 0,
    interactive: 1,
    complete: 2
}

/**
 *
 * SelfInitComponent - for every class / component deriving from it and overriding init, init will be executed on DOMReady
 * @module SelfInitComponent
 */

/** The class SelfInitComponent*/
export default class SelfInitComponent {

    /**
     * constructor: Creates an instance of SelfInitComponent.
     * @param {string} selector selector to find corresponding element in DOM
     * @param {Object} [implementedEvents=null] the options object
     * @param {boolean} [implementedEvents.leading=true] specify invoking on the leading edge of the timeout (setting false: trailing edge of timeout)
     * @param {boolean} [implementedEvents.executeImmediate=false] execute function immediately, then listen for event
     * @param {number} [implementedEvents.debounceTime=50] number of milliseconds to delay
     * @memberof SelfInitComponent
     */
    constructor(selector, implementedEvents = null) {

        const callEvents = () => {
            if (document.querySelectorAll(selector) != null && document.querySelectorAll(selector).length > 0) {
                this.init();
            }
            if (implementedEvents) {
                for (const eventKey in implementedEvents) {
                    if (this.__proto__[eventKey]) {
                        if (implementedEvents[eventKey]) {
                            if (typeof implementedEvents[eventKey] == "object") {
                                if (!implementedEvents[eventKey]["debounce"]) {
                                    window.addEventListener(eventKey, this.__proto__[eventKey]);
                                } else {
                                    debounce(eventKey, this.__proto__[eventKey], implementedEvents[eventKey].debounceTime, implementedEvents[eventKey].trailing);
                                }
                                if (implementedEvents[eventKey]["executeImmediate"]) {
                                    this.__proto__[eventKey]();
                                }
                            } else {
                                debounce(eventKey, this.__proto__[eventKey]);
                            }
                        } else {
                            window.addEventListener(eventKey, this.__proto__[eventKey]);
                        }
                        // eslint-disable-next-line no-undef
                    } else if ((`${BUILDMODE}`) == "development") {
                        //render an error-message in the browser-console in development mode, if there is an event in the given parameter object with no corresponding method
                        // eslint-disable-next-line no-console
                        console.warn(`trying to assign an non-existing function to the event '${eventKey}'`);
                    }
                }
            }

        }

        if (readyStates[document.readyState] < readyStates.interactive) {
            window.addEventListener("load", callEvents);
        } else {
            callEvents();
        }
    }
    // default init method to be overriden by child components
    init() { }
}

function debounce(eventKey, givenFunction, debounceTime = 50, leading = true) {
    const debounced_func = _debounce(givenFunction, debounceTime, {
        leading: leading,
        trailing: !leading
    });
    window.addEventListener(eventKey, debounced_func);
}